import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { add_bulk_download_loading : true, add_bulk_download: null, add_bulk_download_error: false};

export function addBulkDownloadReducer(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ADD_BULK_DOWNLOAD_API:
        return {
            add_bulk_download_loading: true,
            add_bulk_download: null,
            add_bulk_download_error: false
        };
      case organisationConstants.RECIEVE_ADD_BULK_DOWNLOAD_API:
        return {
            add_bulk_download_loading: false,
            add_bulk_download: action.bulkDownload,
            add_bulk_download_error: false
        };
      case organisationConstants.ERROR_ADD_BULK_DOWNLOAD_API:
        return { 
            add_bulk_download_loading: false,
            add_bulk_download: null,
            add_bulk_download_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/bulkDownload/addBulkDownload.js